import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("descripcion.companies_insights_title"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VCol,
                  { staticClass: "text-right", attrs: { cols: "6" } },
                  [
                    _c(VSelect, {
                      staticClass: "con-borde",
                      attrs: { items: _vm.categories, outlined: "", dense: "" },
                      model: {
                        value: _vm.company,
                        callback: function ($$v) {
                          _vm.company = $$v
                        },
                        expression: "company",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(VCardSubtitle),
                _c(
                  VContainer,
                  { staticClass: "justify-center", attrs: { fluid: "" } },
                  [
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          {
                            staticClass: "col-md-10 col-xl-8 col-12",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_000.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_005.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_010.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_011.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_012.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_015.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_019.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_022.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_024.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_032.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_033.png"),
                              },
                            }),
                            _c(VImg, {
                              attrs: {
                                width: "0",
                                height: "0",
                                src: require("@/assets/icons/logo_074.png"),
                              },
                            }),
                            _c("grid-card-component", {
                              attrs: { "custom-cards": _vm.cards },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }